import VueSweetalert2 from "vue-sweetalert2";
import 'sweetalert2/dist/sweetalert2.min.css';

const options = {
    reverseButtons: true,
    confirmButtonText: "confirmText",
    cancelButtonText: "cancelText",
    confirmButtonColor: "#84bd00",
}

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(VueSweetalert2, options);
});
